import { TaskTypesRoutes } from "@coworker/apprestructured/src/home/constants/taskTypesRoutes";
import { TaskType } from "@coworker/apprestructured/src/tasks/enums/taskTypes";

export type ScannerType = "honeywell" | "camera";
export enum ScannerTypeEnum {
  HONEYWELL = 0,
  CAMERA = 1,
}

const taskTypeMap: Partial<Record<TaskType, string>> = {
  [TaskType.ADDON]: TaskTypesRoutes.ADDON,
  [TaskType.PRODUCT_ISSUE]: TaskTypesRoutes.PRODUCT_ISSUE,
  [TaskType.PRODUCT_QUALITY]: TaskTypesRoutes.PRODUCT_QUALITY,
  [TaskType.CUSTOM]: TaskTypesRoutes.CUSTOM,
  [TaskType.PLANNED]: TaskTypesRoutes.NO_TASK_TYPE,
  [TaskType.MFAQ_FOLLOW_UP]: TaskTypesRoutes.NO_TASK_TYPE,
  [TaskType.TESTBUY_FOLLOW_UP]: TaskTypesRoutes.NO_TASK_TYPE,
  [TaskType.ROOM_SETTINGS]: TaskTypesRoutes.NO_TASK_TYPE,
  [TaskType.NO_TASK_TYPE]: TaskTypesRoutes.NO_TASK_TYPE,
};

export function handleScannerRedirectClick(
  selectedScannerType: ScannerType,
  taskType: TaskType,
  index: ScannerTypeEnum,
  navigate: (to: string) => void
) {
  const mappedTaskType = taskTypeMap[taskType] || taskType;
  if (
    index === ScannerTypeEnum.HONEYWELL &&
    selectedScannerType !== "honeywell"
  ) {
    navigate(`/scanner/honeywell/${mappedTaskType}`);
  }
  if (index === ScannerTypeEnum.CAMERA && selectedScannerType !== "camera") {
    navigate(`/scanner/camera/${mappedTaskType}`);
  }
}

export function getCurrentScannerIndex(
  typeOfScanner: ScannerType
): ScannerTypeEnum {
  return typeOfScanner === "honeywell"
    ? ScannerTypeEnum.HONEYWELL
    : ScannerTypeEnum.CAMERA;
}
